import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export default function DashboardSearchInput({
  allowClear = true,
  ariaLabel,
  className,
  onChange,
  placeholder = 'Search',
  prefix = <SearchOutlined />,
  value,
  ...inputProps
}) {
  return (
    <Input
      allowClear={allowClear}
      aria-label={ariaLabel}
      className={className}
      onChange={onChange}
      placeholder={placeholder}
      prefix={prefix}
      value={value}
      {...inputProps}
    />
  );
}
